var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "upload-box" },
        [
          _c(
            "el-upload",
            {
              ref: "upload",
              attrs: {
                action: "",
                "list-type": "picture-card",
                "before-upload": _vm.beforeUpload,
                "on-progress": _vm.onProgressUpload,
                limit: _vm.totalLimit,
                "on-success": _vm.handleSuccess,
                "show-file-list": false,
                multiple: _vm.isMultiple,
              },
            },
            [
              _c("i", {
                staticClass: "el-icon-plus",
                attrs: { slot: "default" },
                slot: "default",
              }),
            ]
          ),
          _c(
            "div",
            { staticClass: "preview-box" },
            _vm._l(_vm.ossList, function (item, index) {
              return _c(
                "div",
                { key: index, staticClass: "item" },
                [
                  _c("el-image", {
                    staticClass: "preview-image",
                    attrs: {
                      src: _vm.ossList[index],
                      "preview-src-list": _vm.ossList,
                    },
                  }),
                  _c("span", { staticClass: "hover-cover" }),
                  _c("i", {
                    staticClass: "el-icon-delete icon",
                    on: {
                      click: function ($event) {
                        return _vm.deleteImage(index)
                      },
                    },
                  }),
                ],
                1
              )
            }),
            0
          ),
        ],
        1
      ),
      _c("div", { staticClass: "upload-alert" }, [
        _vm._v(
          "上传图片只能是 JPG/PNG 格式，且不能超过" +
            _vm._s(_vm.sizeLimit) +
            "MB"
        ),
      ]),
      _c(
        "el-dialog",
        {
          attrs: { visible: _vm.dialogVisible },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("img", {
            attrs: { width: "100%", src: _vm.dialogImageUrl, alt: "" },
          }),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }